// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3ABnD","alert":"SettungsInbox_alert__1dUNH"};